<template>
  <b-form class="text-left" id="noteForm" @submit.stop.prevent="handleSubmit" enctype="multipart/form-data" novalidate>
    <at :members="atlist">
      <div id="NoteToolbar">
        <button class="ql-image" @click="customImageHandler($event)"></button>
        <button class="ql-attachment" @click="messageAttachmentHandler()"></button>
        <button class="ql-bold"></button>
        <button class="ql-italic"></button>
        <button class="ql-underline"></button>
        <button class="ql-strike"></button>
        <span class="ql-formats">
          <button class="ql-list" value="ordered"></button>
          <button class="ql-list" value="bullet"></button>
        </span>
        <button class="ql-link"></button>
      </div>
      <quill-editor v-model="note.text" ref="noteQuillEditor" :options="editorOption" @ready="onEditorReady($event)"></quill-editor>
    </at>
    <Attachments v-if="note.attachments && note.attachments.length > 0" :attachments="note.attachments" :controls="true"/>
    <b-button variant="warning" type="submit">{{submitText}}</b-button>
    <b-button variant="outline-danger" @click="discardNote">Discard</b-button>
  </b-form>
</template>
<script>
import { mapGetters } from 'vuex'
import Attachments from './Attachments'
import Delta from 'quill-delta'
export default {
  name: 'NewNote',
  props: ['entity_with_note_type', 'entity_with_note_id'],
  components: {Attachments, Delta},
  data () {
    return {
      note: {
        text: '',
        entity_with_note_id: '',
        entity_with_note_type: '',
        attachments: []
      },
      editor: Object,
      editorOption: {
        modules: {
          imageResize: true,
          toolbar: {
            container: '#NoteToolbar',
            handlers: {
              'image': function () { return false }
            }
          }
        }
      },
      members: [],
      noteObject: Object,
      showAttachmentsInput: false
    }
  },
  computed: {
    ...mapGetters(['atlist']),
    submitText () {
      if (this.note.id) {
        return 'Save changes'
      } else {
        return 'Add note'
      }
    }
  },
  methods: {

    uploadAttachment (e) {
      for (var i = 0; i < e.target.files.length; i++) {
        var formData = new FormData()
        formData.append('attachment[file]', e.target.files[i])
        this.$http.post('/uploads', formData, { headers: {'Content-Type': 'multipart/form-data'} })
          .then(response => {
            this.message.attachments.push({name: response.data.attachment_name, url: response.data.attachment_url, id: response.data.id, size: response.data.size})
            document.getElementById('messageAttachment').value = ''
          })
          .catch(e => {
            alert(e.response.data)
          })
      }
    },
    messageAttachmentHandler () {
      document.getElementById('messageAttachment').click()
    },
    customImageHandler (event) {
      document.getElementById('quillImage').click()
    },

    saveDroppedImage (event) {
      event.preventDefault()
      if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length) {
        this.uploadImage(event.dataTransfer.files[0])
      }
    },

    savePastedImage (event) {
      if (event.clipboardData && event.clipboardData.items && event.clipboardData.items.length) {
        let items = event.clipboardData && event.clipboardData.items
        for (let i = 0; i < items.length; i++) {
          if (items[i].kind === 'file') {
            this.uploadImage(items[i].getAsFile())
          }
        }
      }
    },

    saveImage (e) {
      this.uploadImage(e.target.files[0])
    },

    uploadImage (file) {
      var vm = this
      var formData = new FormData()
      formData.append('attachment[file]', file)
      this.$http.post('/uploads', formData, { headers: {'Content-Type': 'multipart/form-data'} })
        .then(response => {
          vm.editorRange = vm.editor.getSelection()
          vm.editor.updateContents(new Delta()
            .retain(vm.editorRange.index)
            .delete(vm.editorRange.length)
            .insert({ image: response.data.attachment_url })
          )
          document.getElementById('quillImage').value = ''
        })
        .catch(e => {
          console.error(e)
        })
    },

    onEditorReady (quill) {
      this.editor = quill
      this.editor.root.addEventListener('drop', this.saveDroppedImage, false)
      this.editor.root.addEventListener('paste', this.savePastedImage, false)
    },

    handleSubmit () {
      var vm = this
      vm.noteObject = vm.note
      vm.noteObject.entity_with_note_type = vm.entity_with_note_type
      vm.noteObject.entity_with_note_id = vm.entity_with_note_id
      if (vm.note.id) {
        this.$http.put('/notes/' + vm.note.id, {note: vm.noteObject})
          .then(response => this.submitSuccessful(response))
          .catch(e => { console.log(e.response) })
      } else {
        this.$http.post('/notes', {note: vm.noteObject})
          .then(response => this.submitSuccessful(response))
          .catch(e => { console.log(e.response) })
      }
    },
    submitSuccessful (response) {
      this.note.text = ''
      this.$root.$emit('noteWasAdded', response.data)
    },
    discardNote () {
      this.note = {text: ''}
      this.$root.$emit('closeNoteEdit')
    }
  },
  mounted () {
    this.$root.$on('noteEdit', (item) => {
      this.note = item
    })
  }
}
</script>
<style scoped>
 >>> .ql-container.ql-snow {
    border-style: solid !important;
    border-width: 1px 1px 1px 1px !important;
    border-color: gray !important;
    min-height: 65px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/NewNote.vue